import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-welcome-three',
  templateUrl: './welcome-three.component.html',
  styleUrls: ['./welcome-three.component.css']
})
export class WelcomeThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
